import {UI} from "../../../../stem-core/src/ui/UIBase";

import {Messages} from "../../../Messages";
import {Link} from "../../../../stem-core/src/ui/UIPrimitives";
import {MerchantButton} from "../../../common/MerchantButton";
import {donateMobileState} from "../../inline-donation/DonateMobileState";
import {DONATE_PAGE_URLS} from "../../PaywallConstants";
import {PoweredByBlink} from "../../PoweredByBlink";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {CancelDonationPanelStyle} from "../cancel-donation/CancelDonationPanel";
import {redirectToMerchantHomepage} from "../../../widget/misc/WidgetUtils";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {MessageElement} from "../../../widget/ui/MessageElement";


@registerStyle(CancelDonationPanelStyle)
export class DonationCanceledPanel extends UI.Element {
    render() {
        const {styleSheet} = this;
        const donation = donateMobileState.previouslyCanceledDonation;
        const publicationName = iFrameMerchantService.getMerchant().name;

        return [
            <div className={styleSheet.title}>{Messages.donatePageDonationCanceledTitle}</div>,
            <MessageElement className={styleSheet.text}
                            message={Messages.donatePageDonationCanceledText1(donation.formatPrice())}/>,
            <div className={styleSheet.text}>{Messages.donatePageDonationCanceledText2}</div>,
            <MerchantButton onClick={redirectToMerchantHomepage} className={styleSheet.button}>
                {Messages.returnToHomepage(publicationName)}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.donatePageDonationCanceledMakeDonation} className={styleSheet.link}
                      onClick={() => this.options.changeURL(DONATE_PAGE_URLS.donate, true)} />
            </div>,
            <PoweredByBlink />,
        ];
    }
}
